export * from './aiModels.js';
export const USER_ROLES = ['admin', 'manager', 'designer', 'user'];
export const GROUP_ROLES = ['owner', 'admin', 'member'];
export const MEMORY_CATEGORIES = ['startup', 'general'];
export const DEFAULT_PAGINATION = {
    page: 1,
    perPage: 20,
    sortOrder: 'desc',
};
export const API_PREFIX = '/api';
export const PERMISSION_MODULES = [
    'users',
    'groups',
    'notes',
    'files',
    'categories',
];
/**
 * Default permission sets per role. Roadmap #98 added the `module.{x}.access`
 * axis: each atlas module node carries `requiredPermissions: ["module.X.access"]`,
 * and `useModules` filters the sidebar/dashboard against the user's effective
 * permission set. Admin keeps the wildcard; other roles get a minimal
 * starting kit and can be expanded per-user via the Permissions tab.
 */
export const ROLE_DEFAULT_PERMISSIONS = {
    admin: ['*'],
    manager: [
        'users.view',
        'users.update',
        'groups.view',
        'groups.create',
        'groups.update',
        'groups.manage_members',
        'notes.view',
        'notes.create',
        'notes.update',
        'notes.delete',
        'notes.share',
        'notes.manage',
        'files.view',
        'files.create',
        'files.update',
        'files.delete',
        'files.share',
        'categories.view',
        'categories.create',
        'categories.update',
        // module-access axis (#98)
        'module.users.access',
        'module.groups.access',
        'module.notes.access',
        'module.files.access',
        'module.memory.access',
        'module.canvas.access',
        'module.ai.access',
        'module.atlas.access',
        'module.roadmap.access',
    ],
    designer: [
        'notes.view',
        'notes.create',
        'notes.update',
        'notes.share',
        'files.view',
        'files.create',
        'files.update',
        'files.share',
        'categories.view',
        // module-access axis (#98) — designer is creative-tool focused
        'module.notes.access',
        'module.files.access',
        'module.canvas.access',
        'module.ui.system.access',
        'module.memory.access',
    ],
    user: [
        'users.view',
        'groups.view',
        'notes.view',
        'notes.create',
        'notes.update',
        'notes.delete',
        'notes.share',
        'files.view',
        'files.create',
        'files.update',
        'files.delete',
        'files.share',
        'categories.view',
        // module-access axis (#98)
        'module.notes.access',
        'module.files.access',
        'module.memory.access',
    ],
};
export const NOTE_SHARE_ROLES = ['viewer', 'editor'];
export const NOTE_COLORS = [
    '#EF4444', '#F97316', '#F59E0B', '#22C55E',
    '#3B82F6', '#6366F1', '#A855F7', '#EC4899',
    '#14B8A6', '#64748B',
];
export const FILES_CONFIG = {
    maxFileSize: 50 * 1024 * 1024, // 50MB
    maxStoragePerUser: 500 * 1024 * 1024, // 500MB
    allowedMimeTypes: [
        'image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml', 'image/bmp',
        'application/pdf',
        'text/plain', 'text/csv', 'text/html', 'text/css', 'text/javascript', 'text/markdown',
        'application/json', 'application/xml',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/zip', 'application/x-rar-compressed', 'application/gzip',
        'audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/webm',
        'video/mp4', 'video/webm', 'video/ogg',
    ],
    thumbnailSize: { width: 200, height: 200 },
    previewableTypes: [
        'image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml',
        'application/pdf',
        'text/plain', 'text/csv', 'text/html', 'text/css', 'text/javascript', 'text/markdown',
        'application/json',
        'audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/webm',
        'video/mp4', 'video/webm', 'video/ogg',
    ],
};
export const AI_CHAT_ATTACHMENT_CONFIG = {
    maxFileSize: 10 * 1024 * 1024, // 10MB — MiniMax image understanding limit
    maxAttachments: 5,
    allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    maxImageDimension: 2048, // px — resize threshold
};
export const ATTACHMENT_CONFIG = {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedMimeTypes: [
        'image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml',
        'application/pdf',
        'text/plain', 'text/csv',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/zip',
        'application/json',
    ],
    thumbnailSize: { width: 200, height: 200 },
};
//# sourceMappingURL=index.js.map